import { PayloadDatas } from '../../types';
import { CreativeTagEvent } from '../../enums';
import { CreativeTrackingService } from '../../services/creative-tracking/creative-tracking-service';
import { ParametersExtractor } from '../../parameters-extractor/parameters-extractor';
import { EntryPoint, Player } from '../../types/player';

export class PlayerTrackingHandler {
  constructor(
    protected experiencePlayer: Player | EntryPoint,
    protected creativeTrackingService: CreativeTrackingService,
    protected parameterExtractor: ParametersExtractor
  ) {
    this.attachEventHandlers();
  }

  private attachEventHandlers() {
    [
      CreativeTagEvent.CreativeLoaded,
      CreativeTagEvent.CreativeLoadingFailed,
      CreativeTagEvent.CreativeAssetLoad,
      CreativeTagEvent.CreativeDisplay,
      CreativeTagEvent.CreativeView,
      CreativeTagEvent.CreativeTimespent,
      CreativeTagEvent.CreativeShow,
      CreativeTagEvent.CreativeClicked
    ].forEach(event => {
      this.experiencePlayer.addEventListener(event, evt => {
        this.creativeTrackingService.sendCreativeTagTracking(
          event,
          {
            experience: (this.experiencePlayer as EntryPoint).getExperience
              ? (this.experiencePlayer as EntryPoint).getExperience()
              : null
          } as PayloadDatas,
          evt as CustomEvent
        );
      });
    });
  }
}
